import { render } from "./addCopilot.vue?vue&type=template&id=5a107e25&scoped=true"
import script from "./addCopilot.vue?vue&type=script&lang=js"
export * from "./addCopilot.vue?vue&type=script&lang=js"

import "./addCopilot.vue?vue&type=style&index=0&id=5a107e25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a107e25"]])

export default __exports__